import "./input-text.scss";

import { Image } from "react-bootstrap";
import { ValidIcon } from "src/assets";
import { InputTextProps, typedMemo } from "src/types";
import { formatLabel, formatLabelWithCondition } from "src/utils";

import { useInputText } from "./input-text.hook";
import { kMaxLength } from "buffer";

export const InputText = typedMemo((props: InputTextProps) => {
  const {
    name,
    label,
    validationSchema,
    error,
    touched,
    value,
    readOnly,
    handleChange,
    handleBlur,
    textarea,
    warning,
    icon,
    iconValid = ValidIcon,
    datalist,
    classes = "",
    min,
    maxLength,
    onPaste,
    onCopy,
    requiredCondition,
  } = props;

  const {
    onPressEnabledIcon,
    handleKeyDown,
    allClassesLabel,
    allClassesField,
    allClassesError,
    allClassesWarning,
    allClassesIcon,
    inputProps,
  } = useInputText(props);

  ////////////////////////////////////////////////////////////////////////////////////////////////////

  const Label = (
    <label htmlFor={name} className={allClassesLabel}>
      {requiredCondition == null && formatLabel(validationSchema, name, label)}
      {requiredCondition != null &&
        formatLabelWithCondition(label, requiredCondition)}
    </label>
  );

  const InputNormal = (
    <input
      maxLength={maxLength}
      list={`${name}-datalist`}
      onChange={handleChange}
      onBlur={handleBlur}
      onPaste={onPaste}
      onCopy={onCopy}
      readOnly={readOnly}
      {...inputProps}
      onKeyDown={handleKeyDown}
    />
  );

  const InputTextArea = (
    <textarea
      maxLength={maxLength}
      {...inputProps}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  );

  const Field = (
    <div className={allClassesField}>
      {textarea ? InputTextArea : InputNormal}
      {icon && (
        <Image
          width={36}
          src={icon}
          className={allClassesIcon}
          onClick={onPressEnabledIcon}
        />
      )}
      {iconValid &&
        !textarea &&
        !error &&
        (value || value?.toString() === "0") && (
          <Image
            width={36}
            src={iconValid}
            className="input-text--icon-valid"
          />
        )}
    </div>
  );

  const Error = <p className={allClassesError}>{error}</p>;

  const Warning = <p className={allClassesWarning}>{`${warning} `}</p>;

  const Datalist = (
    <datalist id={`${name}-datalist`}>
      {datalist?.map((data, index) => (
        <option key={index} value={data} />
      ))}
    </datalist>
  );

  const MaxLenght = (
    <div className="label-m mt-1 mb-2 text-end">
      {value?.length} / {maxLength}
    </div>
  );

  ////////////////////////////////////////////////////////////////////////////////////////////////////

  return (
    <main id={`input-${name}`} className={classes}>
      <div className="d-flex flex-column">
        {Label}
        {Field}
        {maxLength && MaxLenght}
        {warning && Warning}
        {error && touched ? Error : <p></p>}
        {datalist && Datalist}
      </div>
    </main>
  );
});
